<ng-container *ngIf="{isTop: isTopNav$ | async} as navigation">
  <header *ngIf="showHeader()" [ngClass]="{'header--top-nav-transparent-sticky' : isTopNavTransparentSticky}"
          class="header">

    <a (click)="goToMain('main-content')" [core-analytics]="{action: 'Skip to main content', category: 'HEADER'}" class="skip-to-content visually-hidden-focusable"
       href="javascript:void(0)"
    >
      <span class="skip-to-content__link">Skip to main content</span>
    </a>

    <core-side-nav *ngIf="!navigation.isTop"></core-side-nav>
    <core-top-navigation *ngIf="navigation.isTop"></core-top-navigation>

  </header>
</ng-container>
